/* bristm-work — section script (loaded only where the section renders) */
(function () {
  function initWork(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('[data-b-work-card]').forEach(function (card) {
      if (card.dataset.bWorkBound) return;
      card.dataset.bWorkBound = '1';
      var media = card.querySelector('.b-work__media');
      if (!media) return;
      var frame = 0;
      var px = 0;
      var py = 0;
      media.addEventListener(
        'mousemove',
        function (e) {
          px = e.clientX;
          py = e.clientY;
          if (frame) return;
          frame = requestAnimationFrame(function () {
            frame = 0;
            var r = media.getBoundingClientRect();
            media.style.setProperty('--b-dx', px - r.left - r.width / 2 + 'px');
            media.style.setProperty('--b-dy', py - r.top - r.height / 2 + 'px');
          });
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWork(document);
    });
  } else {
    initWork(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initWork(e.target);
  });
})();
